import src from "IMAGE";
export default { src, width: 1494, height: 4872, blurWidth: 2, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAAGklEQVR42qXGMQ0AAAACIGb/0D428GADMk8KBJgAId2RLkUAAAAASUVORK5CYII="};
